<template>
  <DetailTemplate
    :custom-class="'invoice-detail detail-page'"
    v-if="getPermission('invoice:view')"
  >
    <template v-slot:sidebar-detail>
      <div class="d-flex align-center" v-if="pageLoaded">
        <v-chip
          v-if="statusMap[detail.status]"
          :color="statusMap[detail.status].color"
          :text-color="statusMap[detail.status].textColor"
          label
          class="ml-2 mx-2 font-weight-600 text-uppercase justify-center font-10"
        >
          {{ statusMap[detail.status].text }}
        </v-chip>

         <v-chip
          v-if="detail.type"
          color="orange"
          text-color="white"
          label
          class="ml-2 mx-2 font-weight-600 text-uppercase justify-center font-10"
        >
          {{ detail.type }}

        </v-chip>


      </div>

       <div class="mt-5">

        <table width="100%">

                 <tr>
                    <th class="grey lighten-4 font-size-18 color-custom-blue py-1">
                      INVOICE INFORMATION
                    </th>
                    <th class="grey lighten-4 font-size-18 color-custom-blue py-1"></th>
                </tr>

                 
                <tr>
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Invoice #
                  </td>
                  <td valign="middle" class="py-1 font-size-18 font-weight-500">
                    <label class="m-0"> 
                      <v-chip
                        label
                        color="chip-custom-blue"
                        outlined
                        class="my-1 custom-barcode font-weight-600"
                        style="font-size: 12px !important; font-weight: 700"
                        >{{ detail.barcode }}</v-chip
                      >
                    </label>
                  </td>
                </tr>

                <tr>
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Group ID
                  </td>
                  <td valign="middle" class="py-1 font-size-18 font-weight-500">
                    <label class="m-0"> 
                      <v-chip
                        label
                        color="chip-custom-blue"
                        outlined
                        class="my-1 custom-barcode font-weight-600"
                        style="font-size: 12px !important; font-weight: 700"
                        >{{ detail.group_id }}</v-chip
                      >
                    </label>
                  </td>
                </tr>

                <tr v-if="detail.other_invoice && detail.other_invoice.id">
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                     {{ detail.type == 'Customer' ? 'Funding Organisation Invoice' : 'Customer Invoice' }}
                  </td>
                  <td valign="middle" class="py-1 font-size-18 font-weight-500">
                    <label class="m-0"> 
                      <v-chip
                        
                        label
                        color="chip-custom-blue"
                        outlined
                        class="my-1 custom-barcode font-weight-600"
                        style="font-size: 12px !important; font-weight: 700"
                        @click="toInvoice(detail.other_invoice)"
                        >{{ detail.other_invoice?.barcode }}</v-chip
                      >
                    </label>
                  </td>
                </tr>


                <tr>
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Reference 
                  </td>
                    <td valign="middle" class="py-1 font-size-18 font-weight-500">
                    <label v-if="detail.reference" class="m-0">{{ detail.reference }}</label>
                     <template v-else
                            ><em class="text-muted py-1"
                      >No Reference</em
                  ></template>
                  </td>
                 
                </tr>
               
                 <tr>
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Payment Type 
                  </td>
                    <td valign="middle" class="py-1 font-size-18 font-weight-500 text-capitalize">
                    <label v-if="detail.payment_type" class="m-0">{{ detail.payment_type }}</label>
                      <template v-else
                            ><em class="text-muted py-1"
                      >No payment type</em
                  ></template>
                  </td>
                
                </tr>

                <tr v-if="detail.funding_organisation">
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Funding Organisation 
                  </td>

                   <td valign="middle" class="py-1 font-size-18 font-weight-500 text-capitalize">
                    <label v-if="detail.funding_organisation" class="m-0">{{ detail.funding_organisation }}</label>
                     <template v-else
                            ><em class="text-muted py-1"
                      >No funding organisation</em
                  ></template>
                  </td>

                </tr>

                
                <tr v-if="detail.copayment_amount">
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Copayment Amount 
                    

                  </td>
                    <td valign="middle" class="py-1 font-size-18 font-weight-500">
                     <label class="m-0" v-if="detail.copayment_amount">{{ formatMoney(detail.copayment_amount) }}</label>
                  
                  <template v-else
                            ><em class="text-muted py-1"
                      >No copayment amount</em
                  ></template>
                  </td>
                </tr>

                <tr v-if="detail.pro_rated_copayment_amount">
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Pro-rated Copayment Amount
                  </td>
                    <td valign="middle" class="py-1 font-size-18 font-weight-500">
                     <label class="m-0" v-if="detail.pro_rated_copayment_amount">{{ formatMoney(detail.pro_rated_copayment_amount) }}</label>
                  
                  <template v-else
                            ><em class="text-muted py-1"
                      >No Pro-rated copayment amount</em
                  ></template>
                  </td>
                </tr>

                <tr>
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Consolidated Trips 
                  </td>
                    <td valign="middle" class="py-1 font-size-18 font-weight-500">
                      <label class="m-0" v-if="detail.consolidated_trips">{{ detail.consolidated_trips }}</label>
                    <template v-else
                            ><em class="text-muted py-1"
                      >No consolidated trips</em
                    ></template>  
                  </td>
                </tr>



                <tr v-if="detail.payment_due">
                  <td valign="middle" class="py-1 font-size-18 font-weight-600 text-capitalize" >
                    Payment due
                  </td>
                  <td valign="middle" class="py-1 font-size-18 font-weight-500">
                    <label class="m-0">{{ detail.payment_due.text }}</label>
                  </td>
                </tr>

                 <tr>
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Total Amount
                  </td>
                  <td valign="middle" class="py-1 font-size-18 font-weight-500">
                    <label class="m-0" v-if="detail.type == 'Funding Organisation' || !detail.other_invoice">{{
                      formatMoney(detail.total)
                    }}</label>
                    <label class="m-0" v-else>{{ formatMoney(detail.other_invoice?.total) }}</label>
                  </td>
                </tr>
                <tr>
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Payable Amount
                  </td>
                  <td valign="middle" class="py-1 font-size-18 font-weight-500">
                    <label class="m-0 red--text">{{
                      formatMoney(grandTotal)
                    }}</label>
                  </td>
                </tr>
               

                <tr>
                    <th class="grey lighten-4 font-size-18 color-custom-blue py-1">
                      INVOICE DATES
                    </th>
                    <th class="grey lighten-4 font-size-18 color-custom-blue py-1"></th>
                </tr> 

                <tr>
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Invoice Date
                  </td>
                  <td valign="middle" class="py-1 font-size-18 font-weight-500">
                    <label class="m-0">
                      {{ formatDate(detail.invoice_date) }}
                    </label>
                  </td>
                </tr>

                <tr>
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Invoice Due Date
                  </td>
                  <td valign="middle" class="py-1 font-size-18 font-weight-500">
                    <label class="m-0">{{
                      formatDate(detail.due_date)
                    }}</label>
                  </td>
                </tr>

                <tr v-if="detail.pending_amount">
                  <td valign="middle" class="py-1 font-size-18 font-weight-600">
                    Invoice Sent Date
                  </td>
                  <td valign="middle" class="py-1 font-size-18 font-weight-500">
                    <label class="m-0">{{
                      formatDate(detail.sent_date)
                    }}</label>
                  </td>
                </tr>

              </table>


       </div>
    </template>

    <template v-slot:header-title>
     
      <span
        class="color-custom-blue font-weight-700 font-size-26 text-capitalize"
        v-if="detail && detail.title"
      >
        {{ detail.title }}
      </span>
      <!-- </v-chip> -->
    </template>

    <template v-slot:header-action>
      <div class="d-flex align-center justify-end" v-if="pageLoaded">
             
              <template v-if="!detail.sent_date && detail.status != 5 && detail.other_invoice?.status != 3 && detail.status != 3 &&
            (
              (detail.type === 'Customer' && !detail.other_invoice) ||
              detail.type === 'Funding Organisation'
            )">
            
                <v-tooltip top content-class="custom-top-tooltip">
                  <template v-slot:activator="{ on, attrs }">

                    <v-btn
                      :disabled="invoiceLoading"
                      class="mx-2 custom-bold-button white--text"
                      color="cyan"
                      v-bind="attrs"
                      v-on="on"
                      v-on:click="updateMoreAction('edit')"
                    >
                      <v-icon left>mdi-pencil</v-icon> Edit
                    </v-btn>
                  </template>
                  <span>Click here to edit Invoice</span>
                </v-tooltip>
              </template>
              
              <v-btn
                v-on:click="updateMoreAction('record-payment')"
                depressed
                v-if="detail.status === 4 && grandTotal > 0" 
                color="cyan white--text"
                class="custom-bold-button mx-2"
                ><v-icon small left>mdi-credit-card-plus-outline</v-icon>Record
                Payment</v-btn
              >
       
        <v-menu
          transition="slide-y-transition"
          bottom
          content-class="custom-menu-list"
          offset-y
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="statusLoading"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              v-bind="attrs"
              v-on="on"
            >
              More... <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <template v-for="(more, index) in moreActions">
              <v-list-item
                link
                v-on:click="updateMoreAction(more.action)"
                :key="index"
                :disabled="statusLoading || more.disabled"
              >
                <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                  <v-icon class="icon-default-blue">{{ more.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="font-weight-500 font-size-14">{{
                  more.title
                }}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="goBack()"
        >
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </div>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll invoice-detail-height"
        style="position: relative"
      >
        <v-container fluid class="py-0">
          <v-row v-if="pageLoaded">

            <v-col md="12" class="pt-0">
              <v-tabs
                active-class="custom-tab-active"
                v-model="invoiceTab"
                background-color="transparent"
                color="cyan"
                class="custom-tab-transparent tab-sticky"
              >
                <v-tab class="font-size-16 font-weight-600 px-8" href="#other">
                  <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                    <!--begin::Svg Icon-->
                    <inline-svg
                      :src="$assetURL('media/custom-svg/invoice.svg')"
                    />
                    <!--end::Svg Icon-->
                  </span>
                  Overview
                </v-tab>
                <v-tab
                  class="font-size-16 font-weight-600 px-8"
                  href="#line-item"
                >
                  <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                    <!--begin::Svg Icon-->
                    <inline-svg
                      :src="$assetURL('media/custom-svg/line-item.svg')"
                    />
                    <!--end::Svg Icon-->
                  </span>
                  Line Items
                </v-tab>

                 <v-tab class="font-size-16 font-weight-600 px-4" :href="'#attachments'">
                    <v-icon small color="#24326d" left>mdi-file-multiple</v-icon>
                   Attachments
                  </v-tab>
                
                <v-tab
                  class="font-size-16 font-weight-600 px-8"
                  href="#history"
                >
                  <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                    <!--begin::Svg Icon-->
                    <inline-svg
                      :src="$assetURL('media/custom-svg/history.svg')"
                    />
                    <!--end::Svg Icon-->
                  </span>
                  History
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="invoiceTab">
                <v-tab-item value="other">
                  <v-container fluid class="ps-0">
                  <v-row >
                   <v-col md="12" class="pt-0 pe-0">
            
                 <v-card
                      flat
                      class="custom-grey-border remove-border-radius mb-1 mt-2 mr-0"
                    >
                      <v-card-title class="headline grey lighten-4 mr-0">
                        <span
                          class="font-weight-700 custom-headline color-custom-blue font-size-16"
                          >Location Detail</span
                        >
                      </v-card-title>
                      <v-card-text class="p-6 font-size-16">
                        <span class="color-custom-blue font-weight-700 font-size-19 text-capitalize">
                        <router-link
                          :to="
                            getDefaultRoute('customer.detail', {
                              params: {
                                id: detail.customer.id,
                              },
                            })
                          "
                          >{{ detail.customer.display_name }}
                        </router-link>
              </span>
              <v-layout class="my-4">
                <v-flex md6 class="mr-2 custom-border-right"> 
                  <table width="100%">
                    <tr>
                      <td class="font-weight-700 custom-headline font-size-16" style="color: black; font-weight: bold;">Address</td>
                    </tr>
                    <tr>
                      <td class="py-0 font-size-18 font-weight-500">
                        <a
                          target="_blank"
                          :href="`https://maps.google.com/?q=${detail.property.property_address}`"
                          style="color: black !important"
                          >{{ detail.property.property_address }}</a
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-700 custom-headline  font-size-16" style="color: black; font-weight: bold;">Contact details</td>
                    </tr>
                    <tr v-if="detail.property_person.display_name">
                      <td class="py-0 font-size-18 font-weight-500" style="color: black !important">
                        {{ detail.property_person.display_name }}
                      </td>
                    </tr>
                    <tr v-if="detail.property_person.primary_phone">
                      <td class="py-0 font-size-18 font-weight-500" style="color: black !important">
                        {{ detail.property_person.primary_phone }}
                      </td>
                    </tr>
                    <tr v-if="detail.property_person.primary_email">
                      <td class="py-0 font-size-18 font-weight-500" style="color: black !important">
                        {{ detail.property_person.primary_email }}
                       <!-- <v-icon
                          v-if="detail.property_person_notify"
                          v-tippy="{
                            arrow: true,
                            arrowType: 'round',
                            animation: 'fade',
                          }"
                          content="Notification was sent to given email"
                          color="green lighten-1"
                          >mdi-check</v-icon
                        > -->
                      </td>
                    </tr>
                  </table>
                </v-flex>
                <v-flex md6 class="ml-2">
                  <table width="100%">
                    <tr>
                      <td class="font-weight-700 custom-headline font-size-16" style="color: black; font-weight: bold;">Billing Address</td>
                    </tr>
                    <tr>
                      <td class="py-0 font-size-18 font-weight-500">
                        <a
                          target="_blank"
                          :href="`https://maps.google.com/?q=${detail.billing.property_address}`"
                          style="color: black !important"
                          >{{ detail.billing.property_address }}</a
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-700 custom-headline  font-size-16" style="color: black; font-weight: bold;">Contact details</td>
                    </tr>
                    <tr v-if="detail.billing_person.display_name">
                      <td class="py-0 font-size-18 font-weight-500" style="color: black !important">
                        {{ detail.billing_person.display_name }}
                      </td>
                    </tr>
                    <tr v-if="detail.billing_person.primary_phone" style="color: black !important">
                      <td class="py-0 font-size-18 font-weight-500">
                        {{ detail.billing_person.primary_phone }}
                      </td>
                    </tr>
                    <tr v-if="detail.billing_person.primary_email" style="color: black !important">
                      <td class="py-0 font-size-18 font-weight-500">
                        {{ detail.billing_person.primary_email }}
                       <!-- <v-icon
                          v-if="detail.billing_person_notify"
                          v-tippy="{
                            arrow: true,
                            arrowType: 'round',
                            animation: 'fade',
                          }"
                          content="Notification was sent to given email"
                          color="green lighten-1"
                          >mdi-check</v-icon
                        > -->
                      </td>
                    </tr>
                  </table>
                </v-flex>
              </v-layout>
                      </v-card-text>
                    </v-card>
          
                    </v-col>
                    <v-col md="12" class="pt-0 pe-0">
                    <v-card
                      flat
                      class="custom-grey-border remove-border-radius my-4"
                    >
                      <v-card-title class="headline grey lighten-4">
                        <span
                          class="font-weight-700 custom-headline color-custom-blue font-size-16"
                          >PAYMENT TERMS</span
                        >
                      </v-card-title>
                      <v-card-text class="p-6 font-size-16">
                        <read-more
                          class="mx-4 custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                          more-str="read more"
                          :text="
                            detail.payment_terms || '<em>No Payment Terms</em>'
                          "
                          link="#"
                          less-str="read less"
                          :max-chars="200"
                        >
                        </read-more>
                      </v-card-text>
                    </v-card>
                    </v-col>
                     <v-col md="12" class="pt-0 pe-0">
                    <v-card
                      flat
                      class="custom-grey-border remove-border-radius mb-4"
                    >
                      <v-card-title class="headline grey lighten-4">
                        <span
                          class="font-weight-700 custom-headline color-custom-blue font-size-16"
                          >TERMS &amp; CONDITIONS</span
                        >
                      </v-card-title>
                      <v-card-text class="p-6 font-size-16">
                        <read-more
                          class="mx-4 custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                          more-str="read more"
                          :text="
                            detail.term_conditions ||
                            '<em>No Terms &amp; Conditions</em>'
                          "
                          link="#"
                          less-str="read less"
                          :max-chars="200"
                        >
                        </read-more>
                      </v-card-text>
                    </v-card>
                    </v-col>
                     <v-col md="12" class="pt-0 pe-0">
                    <v-card
                      flat
                      class="custom-grey-border remove-border-radius mb-4"
                    >
                      <v-card-title class="headline grey lighten-4">
                        <span
                          class="font-weight-700 custom-headline color-custom-blue font-size-16"
                          >INTERNAL NOTES</span
                        >
                      </v-card-title>
                      <v-card-text class="p-6 font-size-16">
                        <v-layout class="mb-4">
                          <v-flex md6 class="custom-border-right">
                            <read-more
                              class="mx-4 custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                              more-str="read more"
                              :text="
                                detail.client_remark ||
                                '<em>No Client Notes</em>'
                              "
                              link="#"
                              less-str="read less"
                              :max-chars="200"
                            >
                            </read-more>
                          </v-flex>
                          <v-flex md6>
                            <read-more
                              class="mx-4 custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                              more-str="read more"
                              :text="
                                detail.admin_remark || '<em>No Admin Notes</em>'
                              "
                              link="#"
                              less-str="read less"
                              :max-chars="200"
                            >
                            </read-more>
                          </v-flex>
                        </v-layout>
                       
                      </v-card-text>
                    </v-card>
                    </v-col>
                     </v-row>
                  </v-container>
                </v-tab-item>

                 <v-tab-item :value="'attachments'">
                    <div class="service-detail-height">
                      <AdditionalDocuments
                      :type-id="detail.id"
                      class="mx-0"
                      type-text="Invoice Attachments"
                      :type="3"
                      :extensive="false"
                      ></AdditionalDocuments>
                    </div>
                  </v-tab-item>
                  
                <v-tab-item value="line-item">

                  <InvoiceLineItem
                    :key="invoiceId"
                    :show-price= true
                    :discount-level="detail.discount_type == 2 ? 'line_item' : 'transaction'"
                    :related-id="invoiceId"
                    :related-type="2"
                    :related-data="detail"

                  ></InvoiceLineItem>

                   <div
                  class="mt-4 pr-2 font-weight-600"
                  v-if="delivery?.type != 'incoming'"
                >
                  <table width="100%">
                    <tr>
                      <td width="66%"></td>
                      <td width="18%" align="right">Sub Total</td>
                      <td width="18%" align="right">
                        {{ formatMoney(detail.sub_total) }}
                      </td>
                    </tr>
                    <tr v-if="detail.discount_type == 1 && detail.type !== 'Funding Organisation' && detail.discount_amount > 0">
                      <td></td>
                      <td align="right">
                        Discount
                        <span v-if="detail.discount_value_type == 1"
                          >({{ formatMoney(detail.discount_value) }})</span
                        >
                        <span v-if="detail.discount_value_type == 2"
                          >({{ formatNumber(detail.discount_value) }}%)</span
                        >
                      </td>
                      <td align="right">
                        {{ formatMoney(detail.discount_amount) }}
                      </td>
                    </tr>

                     <tr v-if="detail.tax_applied > 0 && (detail.type ==  'Funding Organisation' || detail.funding_group_id <= 0)">
                      <td></td>
                      <td align="right">Tax [GST {{ detail.tax_value }}%]</td>
                      <td align="right">
                        {{ formatMoney(taxAmount) }}
                      </td>
                    </tr>

                    <tr v-if="detail.type == 'Funding Organisation'">
                      <td></td>
                      <td align="right">After Tax Amount</td>
                      <td align="right">
                        {{ formatMoney(afterTaxAmount) }}
                      </td>
                    </tr>

                   <tr v-if="detail.type == 'Funding Organisation'">
                    <td></td>
                    <td align="right">
                        {{ detail.pro_rated_copayment_amount > 0 ? 'Pro-rated Copayment Amount' : 'Copayment Amount' }}
                         <v-tooltip top  v-if="(detail.copayment_amount > detail.sub_total) || (detail.pro_rated_copayment_amount > detail.sub_total)">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="blue"
                                small
                                class="ml-1"
                                style="cursor: pointer; vertical-align: middle;"
                              >
                                mdi-information
                              </v-icon>
                            </template>
                            <span>
                              <strong>Note:</strong><br />
                              
                              • Pro-rated Copayment/Copayment &gt; Sub Total, <br/>
                                  Pro-rated Copayment / Copayment = Sub Total.<br />
                              
                            </span>
                          </v-tooltip> 
                    </td>
                    <td align="right">
                      {{ formatMoney(copaymentAmount) }}
                    </td>
                  </tr>

                   
                    <tr v-if="detail.type !== 'Funding Organisation' && detail.adjustment > 0">
                      <td></td>
                      <td align="right">Adjustment</td>
                      <td align="right">
                        {{ formatMoney(detail.adjustment) }}
                      </td>
                    </tr>
                    <tr class="font-size-19">
                      <td></td>
                      <td align="right">Grand Total</td>
                      <td align="right">{{ formatMoney(grandTotal) }}</td>
                    </tr>
                  </table>
                </div>
                </v-tab-item>
                <v-tab-item value="quotation">
                  <InternalQuotation
                    type="invoice"
                    :type-id="invoiceId"
                  ></InternalQuotation>
                </v-tab-item>
                <v-tab-item value="visit">
                  <InternalVisit
                    is-admin
                    visit-type="all"
                    internal
                    :invoice-id="detail.id"
                    :customer-id="detail.customer.id"
                    :entity-id="detail.entity_id"
                  ></InternalVisit>
                </v-tab-item>
                <v-tab-item value="history">
                  <InternalHistoryDetail
                    type="invoice"
                    :type_id="detail.id"
                  ></InternalHistoryDetail>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-container>
      </perfect-scrollbar>
    
      <CreatePaymentTemplate
        :detail="detail"
        :dialog="paymentDialog"
        v-on:close="paymentDialog = false"
        v-on:success="getInvoice()"
      ></CreatePaymentTemplate>
    </template>
  </DetailTemplate>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CommonMixin from "@/core/plugins/common-mixin";
import DetailTemplate from "@/view/pages/partials/Detail-Template-New.vue";

import InvoiceLineItem from "@/view/components/VisitLineItem.vue";
import InternalQuotation from "@/view/pages/partials/Internal-Quotation";

import InternalVisit from "@/view/pages/visit/Visit-Listing-Template";
import CreatePaymentTemplate from "@/view/pages/invoice/Create-Payment.vue";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import { GET,PATCH } from "@/core/services/store/request.module";
import JwtService from "@/core/services/jwt.service";
import AdditionalDocuments from "@/view/pages/engineer/Additional-Documents";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      invoiceId: 0,
      pageLoaded: false,
      statusLoading: false,
      paymentDialog: false,
      mail_dialog: false,
      invoiceLoading: false,
      invoiceTab: "other",
      moreActions: [],
      detail: {},
      dbLineItems: [],
      dbEquipments: [],
      statusMap: {
        1: { text: 'Draft', color: 'cyan', textColor: 'white' },
        2: { text: 'Unpaid', color: 'blue', textColor: 'white' },
        3: { text: 'Paid', color: 'green', textColor: 'white' },
        4: { text: 'Sent', color: 'orange', textColor: 'white' },
        5: { text: 'Cancelled', color: 'red', textColor: 'white' },
        6: { text: 'Rejected', color: 'cyan', textColor: 'white' }
      }
    };
  },
  methods: {
    pushToVisit(id) {
      this.$router.push(
        this.getDefaultRoute("quotation.detail", {
          params: { id: id },
        })
      );
    },

  toInvoice(detail) {
    this.$router.push(
    this.getDefaultRoute("invoice.detail", {
      params: { id: detail.id },
      query: { reload: Date.now() } 
    })
    );
  },

    getDurationText() {
      const start_date = this.lodash.head(this.detail.duration);
      const last_date = this.lodash.last(this.detail.duration);
      return `${this.formatDate(start_date)} to ${this.formatDate(last_date)}`;
    },

     routeToPayment() {
      this.$router.push(
        this.getDefaultRoute("payment", {
          query: {
            new: true,
            customer: this.detail?.customer,
            invoice: this.invoiceId,
          },
        })
      );
    },
    updateMoreAction(type) {
      switch (type) {
        case "edit":
          this.editInvoice();
          break;
        case "record-payment":
          this.routeToPayment();
          break;  
        case "payment":
          this.paymentDialog = true;
          break;
        case "convert_visit":
          this.routeToJob();
          break;
        case "convert_quotation":
          this.routeToQuotation();
          break;
        case "duplicate":
          this.routeToDuplicate();
          break;
        case "mark_as_cancelled":
          this.updateStatus("mark_as_cancelled");
          break;
        case "mark_as_sent":
           this.updateStatus("mark_as_sent");
          break;
        case "download_pdf":
          this.downloadPDF();
          break;
        case "print":
          this.printPDF();
          break;
      }
    },
    updateStatus(status) {
      if (this.statusLoading) {
        return false;
      }
      this.statusLoading = true;
      this.$store
        .dispatch(PATCH, {
          url: "invoice/" + this.invoiceId + "/status",
          data: { status },
        })
        .then(() => {
          this.getInvoice();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.statusLoading = false;
        });
    },
    downloadPDF() {
      const { id } = this.detail;
      const token = JwtService.getToken();
      const url = `${this.$apiURL}invoice/${id}/pdf/download?token=${token}`;
      window.open(url, "_blank");
    },
    printPDF() {
      const { id } = this.detail;
      const token = JwtService.getToken();
      const url = `${this.$apiURL}invoice/${id}/print?token=${token}`;
      window.open(url, "_blank");
    },
    routeToJob() {
      const { billing, billing_person, customer, property, property_person } =
        this.detail;
      this.$router.push(
        this.getDefaultRoute("job.create", {
          query: {
            invoice: this.invoiceId,
            customer: customer ? customer.id : null,
            property_contact_person: property_person
              ? property_person.id
              : null,
            billing_contact_person: billing_person ? billing_person.id : null,
            property: property ? property.id : null,
            billing: billing ? billing.id : null,
          },
        })
      );
    },
    routeToQuotation() {
      const { billing, billing_person, customer, property, property_person } =
        this.detail;
      this.$router.push(
        this.getDefaultRoute("quotation.create", {
          query: {
            invoice: this.invoiceId,
            customer: customer ? customer.id : null,
            property_contact_person: property_person
              ? property_person.id
              : null,
            billing_contact_person: billing_person ? billing_person.id : null,
            property: property ? property.id : null,
            billing: billing ? billing.id : null,
          },
        })
      );
    },
    routeToDuplicate() {
      const { billing, billing_person, customer, property, property_person } =
        this.detail;
      this.$router.push(
        this.getDefaultRoute("invoice.create", {
          query: {
            customer: customer ? customer.id : null,
            billing: billing ? billing.id : null,
            property: property ? property.id : null,
            property_person: property_person ? property_person.id : null,
            billing_person: billing_person ? billing_person.id : null,
            duplicate: this.invoiceId,
          },
        })
      );
    },
    reviseInvoice() {
      const { billing, billing_person, customer, property, property_person } =
        this.detail;
      this.$router.push(
        this.getDefaultRoute("invoice.create", {
          query: {
            customer: customer ? customer.id : null,
            billing: billing ? billing.id : null,
            property: property ? property.id : null,
            property_person: property_person ? property_person.id : null,
            billing_person: billing_person ? billing_person.id : null,
            revise: this.invoiceId,
          },
        })
      );
    },
    editInvoice() {
      const {customer} =
        this.detail;
      this.$router.push(
        this.getDefaultRoute("invoice.update", {
          params: {
            id: this.invoiceId,
          },
          query: {
            customer: customer ? customer.id : null,
          },
        })
      );
    },
    getInvoice() {
      this.$store
        .dispatch(GET, { url: "invoice/" + this.invoiceId })
        .then(({ data }) => {
          this.detail = data;

           if (data.status === 3 && Array.isArray(data.more_actions)) {
              this.moreActions = data.more_actions.filter(
              item => item.action === "download_pdf"
              );
          }
           else {

          this.moreActions = data.more_actions;

        }
         
            
          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Invoice", route: "invoice" },
            { title: "Detail" },
            { title: data.barcode },
          ]);
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.pageLoaded = true;
        });
    },
  },
  created() {
    this.invoiceId = this.lodash.toSafeInteger(this.$route.params.id);
  },

  beforeRouteUpdate(to, from, next) {
      this.invoiceId = to.params.id;
      this.getInvoice();
      next();
  },
  mounted() {
    this.invoiceId = this.$route.params.id;
    this.getInvoice();
  },
  computed: {
    currentStatus() {
      return this.statusMap[this.detail.status] || { text: 'Unknown', color: 'grey', textColor: 'white' };
    },

   copaymentAmount() {

    const proRated = parseFloat(this.detail.pro_rated_copayment_amount) || 0;
    const copayment = parseFloat(this.detail.copayment_amount) || 0;

    const subtotal = parseFloat(this.detail.sub_total);

    let selectedCopayment = proRated > 0 ? proRated : copayment;

     if (selectedCopayment > subtotal) {

        selectedCopayment = subtotal;
        
      }

    return selectedCopayment; 
    
  },

    taxableAmount() {

      const taxable = this.detail.sub_total - this.copaymentAmount;
      return Math.max(taxable, 0);
    
    },

    taxAmount() {

      if (this.detail.type === 'Funding Organisation') {

          return this.detail.sub_total * (this.detail.tax_value / 100);
      }
        return this.detail.tax_amount;
    },

   afterTaxAmount() {

      if (this.detail.type === 'Funding Organisation') {

        return this.detail.sub_total + this.taxAmount;

      }
      return 0;
    },


    grandTotal() {

        if (this.detail.type === 'Funding Organisation') {

           return this.afterTaxAmount - this.copaymentAmount;

        }
        return this.detail.total;

    },

    adjustedProRatedCopaymentAmount() {
      const prorated = parseFloat(this.detail.pro_rated_copayment_amount) || 0;
      const subtotal = parseFloat(this.detail.sub_total) || 0;
      return prorated > subtotal ? subtotal : prorated;
    },

    adjustedCopaymentAmount() {

      const copay = parseFloat(this.detail.copayment_amount) || 0;
      const prorated = parseFloat(this.detail.pro_rated_copayment_amount) || 0;
      if(prorated > 0)
      {
        return copay;
      } 
      const subtotal = parseFloat(this.detail.sub_total) || 0;
      return copay > subtotal ? subtotal : copay;
  },



  },
  components: {
  
    DetailTemplate,
    InternalVisit,
    CreatePaymentTemplate,
    InternalQuotation,
    InvoiceLineItem,
    InternalHistoryDetail,
    AdditionalDocuments
  },
};
</script>
